import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Shield, Users, Target, Award, ArrowRight } from "lucide-react";

const team = [
  {
    name: "John Anderson",
    role: "Founder & Insurance Agent",
    bio: "John Anderson is a dedicated insurance agent with over 10 years of experience. He is committed to helping clients find the best insurance solutions to protect their assets and loved ones.",
    image: "https://images.unsplash.com/photo-1750741268857-7e44510f867d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3Mzc5MjM4Mnww&ixlib=rb-4.1.0&q=85&w=400",
  },
  {
    name: "Joe Anderson",
    role: "Insurance Specialist",
    bio: "Joe Anderson specializes in providing comprehensive coverage for homeowners, auto, commercial, life, health insurance, and annuities. He takes time to understand each client's unique needs.",
    image: "https://images.unsplash.com/photo-1769636930047-4478f12cf430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3Mzc5MjM4Mnww&ixlib=rb-4.1.0&q=85&w=400",
  },
  {
    name: "Gary Fouts",
    role: "Insurance Advisor",
    bio: "Gary Fouts is a trusted insurance advisor passionate about helping individuals and businesses protect their assets and mitigate risks with expert guidance.",
    image: "https://images.unsplash.com/photo-1696699651613-b81a429a0fec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMHRvd24lMjBhbWVyaWNhbiUyMG1haW4lMjBzdHJlZXR8ZW58MHx8fHwxNzczNzkyMzgxfDA&ixlib=rb-4.1.0&q=85&w=400",
  },
  {
    name: "Liza Cabrera",
    role: "Agency Assistant",
    bio: "Liza supports the team and ensures smooth operations so every client receives prompt, professional service.",
    image: "https://images.unsplash.com/photo-1758518727888-ffa196002e59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGJ1c2luZXNzJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzczNzkyMzgzfDA&ixlib=rb-4.1.0&q=85&w=400",
  },
];

export default function AboutPage() {
  return (
    <div>
      {/* Hero */}
      <section className="hero-gradient py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 animate-fade-up">About Us</h1>
          <p className="text-white/70 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto animate-fade-up delay-100">
            Anderson & Anderson Insurance LLC has been protecting families and businesses across Northwest Indiana and the Chicagoland area since 2017.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="bg-white py-16 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wide">Our Mission</span>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#002147] mt-3 mb-6">
                Delivering Reliable Protection & Peace of Mind
              </h2>
              <p className="text-slate-500 leading-relaxed mb-6">
                As an independent insurance agency, we aren't tied to a single insurance carrier. This means we can shop multiple carriers to find you the best coverage at the most competitive price. Our mission is to deliver reliable protection for your assets and peace of mind for your family.
              </p>
              <p className="text-slate-500 leading-relaxed mb-8">
                Founded by John Anderson in 2017, Anderson & Anderson Insurance has grown from a small local agency to a trusted name in Northwest Indiana and the Chicagoland area. We serve clients in Indiana, Illinois, Michigan, Ohio, and Florida — with LegalShield available in most states and travel insurance sold anywhere in the USA.
              </p>
              <div className="grid grid-cols-2 gap-6">
                {[
                  { icon: Shield, label: "Independent Agency" },
                  { icon: Users, label: "Client-First Approach" },
                  { icon: Target, label: "Customized Solutions" },
                  { icon: Award, label: "10+ Years Experience" },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center">
                      <item.icon className="h-5 w-5 text-[#D4AF37]" />
                    </div>
                    <span className="text-sm font-medium text-[#002147]">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1696699651613-b81a429a0fec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMHRvd24lMjBhbWVyaWNhbiUyMG1haW4lMjBzdHJlZXR8ZW58MHx8fHwxNzczNzkyMzgxfDA&ixlib=rb-4.1.0&q=85&w=700"
                alt="Crown Point Indiana main street"
                className="rounded-2xl shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section data-testid="team-section" className="bg-[#F8FAFC] py-16 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 lg:mb-16">
            <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wide">Our Team</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#002147] mt-3 mb-4">
              Meet the People Behind Your Protection
            </h2>
            <p className="text-slate-500 text-base max-w-2xl mx-auto">
              A dedicated team committed to bringing their best in providing you with the right insurance coverage.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, i) => (
              <div
                key={i}
                data-testid={`team-member-${member.name.toLowerCase().replace(/\s/g, '-')}`}
                className="bg-white rounded-xl shadow-sm overflow-hidden card-hover group"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-lg font-semibold text-[#002147]">{member.name}</h3>
                  <p className="text-[#D4AF37] text-sm font-medium mb-3">{member.role}</p>
                  <p className="text-slate-500 text-sm leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hero-gradient py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-4">
            Let's Work Together
          </h2>
          <p className="text-white/70 text-base lg:text-lg mb-8 max-w-xl mx-auto">
            Ready to find the perfect coverage? Contact our team today for a personalized consultation.
          </p>
          <Link to="/contact">
            <Button data-testid="about-cta-btn" className="bg-[#D4AF37] text-[#002147] hover:bg-[#B5952F] font-bold px-8 py-3 h-auto text-base rounded-md shadow-lg">
              Get Started
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
